module.exports = __webpack_public_path__ + "img/custom_aluminum.92a63833.jpg";